import { render } from "./Player.vue?vue&type=template&id=2124a2fa"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=2124a2fa&lang=css"

import exportComponent from "C:\\Users\\Oliver Traber\\Nextcloud\\VSCode Projects\\video-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__